var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"tw:flex tw:items-center tw:gap-2 tw:font-semibold tw:text-xs tw:uppercase",class:_setup.variantClasses,attrs:{"data-test":"badge"}},[(_vm.icon)?_c('i',{class:_vm.icon,attrs:{"data-test":"badge-icon"}}):_vm._e(),_vm._t("default",function(){return [_vm._v(_vm._s(_vm.label))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }